module.exports = __webpack_public_path__ + "static/media/touch.b6a21092.png";